import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

type Props = {
  can_view?: boolean;
};

export const DocNoViewBadge = ({can_view}: Props) => {
  if (can_view) {
    return null;
  }

  return (
    <LazyTooltip
      placement="top"
      tooltip={gt('You do not have access to view this procedure.')}
    >
      <span className="ml-1 badge badge-warning">
        <i className="fa fa-fw fa-lock" /> {gt('Access locked')}
      </span>
    </LazyTooltip>
  );
};
